export const baseURL = "https://teenpatti.bychance.social/";
export const adminBaseURL = "https://admin.bychance.social/";
export const key = "oMX?fr9rk_XcH67]B,^G[@Wpz:-zkP]D";
